var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"p-3",staticStyle:{"border-radius":"0px"}},[_c('v-toolbar',{directives:[{name:"appcolor",rawName:"v-appcolor"}],attrs:{"color":"white--text","flat":""}},[_vm._t("header",function(){return [_vm._v("Defaut header")]})],2),_c('v-card-text',[_vm._t("cbody",function(){return [_vm._v("Defaut content")]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }